import { Outlet } from 'react-router';
import { ImpersonationBanner } from '@/features/admin/components/ImpersonationBanner';
import { useBranding } from '@/hooks/useBranding';

/**
 * Root layout component.
 *
 * Renders the app shell: impersonation banner (when active),
 * sidebar, header bar, and main content area.
 */
export function Layout() {
  const { platform_name } = useBranding();

  return (
    <div className="flex h-screen flex-col bg-bg-primary text-text-primary">
      {/* Impersonation banner -- only renders when JWT has impersonating=true */}
      <ImpersonationBanner />

      {/* Sidebar + main content row */}
      <div className="flex flex-1 overflow-hidden">
        {/* Sidebar */}
        <aside
          className="hidden w-[var(--sidebar-width)] flex-shrink-0 border-r border-border-default bg-sidebar-bg md:flex md:flex-col"
          data-sidebar
        >
          <div className="flex h-[var(--topbar-height)] items-center px-5">
            <span className="text-lg font-bold text-accent-500">{platform_name}</span>
          </div>
          <nav className="flex-1 overflow-y-auto p-3" aria-label="Histórico de conversas">
            <p className="px-2 text-xs text-text-tertiary">
              Lista de conversas
            </p>
          </nav>
        </aside>

        {/* Main content area */}
        <div className="flex flex-1 flex-col overflow-hidden">
          {/* Header / Topbar */}
          <header
            className="flex h-[var(--topbar-height)] items-center justify-between border-b border-border-default bg-bg-secondary px-4"
            data-topbar
          >
            <span className="text-sm font-medium text-text-secondary">
              Seletor de modelo
            </span>
            <span className="text-sm text-text-tertiary">Configurações</span>
          </header>

          {/* Page content */}
          <main className="flex-1 overflow-y-auto">
            <Outlet />
          </main>
        </div>
      </div>
    </div>
  );
}
